import {
  StampType,
  TimestampDate,
} from '~/common/entities/Employees/EmployeeTypes';
import AutoEndWarningApi from '~/common/api/zeiterfassungServerApi/AutoEndWarningApi';
import LogoutWarningApi from '~/common/api/zeiterfassungServerApi/LogoutWarningApi';
import PauseWarningApi from '~/common/api/zeiterfassungServerApi/PauseWarningApi';
import { Employee } from '~/common/entities/Department/DepartmentTypes';
import { useEmployeesContext } from './state';
import { useStore } from 'zustand';
import React from 'react';
import _ from 'lodash';

export const useIsDisabled = (date: TimestampDate) => {
  return React.useMemo(() => {
    const last = _.last(_.orderBy(date.timestamps, 'start', 'asc'));
    return !!last && !last.end && last.type === StampType.WORK;
  }, [date]);
};

export const useDisabledColor = (disabled: boolean) => {
  return React.useMemo(() => (disabled ? 'gray' : 'black'), []);
};

export function formatEmployeeUsername(employee: Employee) {
  return employee.user.username.split('_').slice(1).join('_');
}

export const useAutoEndWarnings = (
  date: TimestampDate | null | undefined,
  employee: Employee | null | undefined,
) => {
  const employeeStore = useEmployeesContext();
  const { start, end } = useStore(employeeStore, (state) => ({
    start: state.dateFrom.valueOf(),
    end: state.dateTo.valueOf(),
  }));
  const { data } = AutoEndWarningApi.hooks.useEmployeeWarnings({
    id: employee?.id,
    start,
    end,
  });
  return React.useMemo(() => {
    if (!date) {
      return data ?? [];
    }
    return data?.filter((warning) => warning.date === date.id) ?? [];
  }, [data, date]);
};

export const useLogoutWarnings = (
  date: TimestampDate | null | undefined,
  employee: Employee | null | undefined,
) => {
  const employeeStore = useEmployeesContext();
  const { start, end } = useStore(employeeStore, (state) => ({
    start: state.dateFrom.valueOf(),
    end: state.dateTo.valueOf(),
  }));
  const { data } = LogoutWarningApi.hooks.useEmployeeWarnings({
    id: employee?.id,
    start,
    end,
  });
  return React.useMemo(() => {
    if (!date) {
      return data ?? [];
    }
    return data?.filter((warning) => warning.date === date.id) ?? [];
  }, [data, date]);
};

export const usePauseWarnings = (
  date: TimestampDate | null | undefined,
  employee: Employee | null | undefined,
) => {
  const employeeStore = useEmployeesContext();
  const { start, end } = useStore(employeeStore, (state) => ({
    start: state.dateFrom.valueOf(),
    end: state.dateTo.valueOf(),
  }));
  const { data } = PauseWarningApi.hooks.useEmployeeWarnings({
    id: employee?.id,
    start,
    end,
  });
  return React.useMemo(() => {
    if (!date) {
      return data ?? [];
    }
    return data?.filter((warning) => warning.date === date.id) ?? [];
  }, [data, date]);
};
